import * as isEmpty from 'lodash/isEmpty';

export class EsgTranslationUtil {

	/***
	 * @description getEsgLetterRating returns a translated esg letter rating for a esg number rating e.g. will return AAA for 5.2
	 * @param {Object} esgTranslationMap: the object esg rating scale map which is received from config layer.
	 * @param {string} val: the value which needs to be translated.
	 * @returns the translated value
	 */
	public static getEsgLetterRating(esgTranslationMap: { [range: string]: string }, val: string, assignOutOfBoundValues: boolean = true): string {
		let translatedValue = val ?? '';
		if (!isEmpty(esgTranslationMap)) {
			const translationMapValues = Object.keys(esgTranslationMap);
			const minValue = parseFloat(translationMapValues[0].split('-')[0]);
			const maxValue = parseFloat(translationMapValues[translationMapValues.length - 1].split('-')[1]);

			Object.keys(esgTranslationMap).forEach((ratingRange: string, index: number) => {
				const floatedVal = parseFloat(val);
				if (this.checkValueFallsInRange(ratingRange, floatedVal)) {
					translatedValue = esgTranslationMap[ratingRange];
				} else if (assignOutOfBoundValues) {
					// assigns out of bound value to the min or max rating
					if (index === 0 && floatedVal < minValue || index === translationMapValues.length - 1 && floatedVal > maxValue) {
						translatedValue = esgTranslationMap[ratingRange];
					}
				}
			});
		}
		return translatedValue;
	}

	/***
   * @description checkValueFallsInRange checks whether a numerical value falls within a number range separated by hyphen, e.g.1-2.5
   * The max value in the range is always included, while the min value is only included if it is 0. 
   * @param {string} range: the range
   * @param {number} val: the number which needs to be checked.
   * @returns the translated value
   */
	public static checkValueFallsInRange(range: string, val: number): boolean {
		if (range) {
			const min = parseFloat(range.split('-')[0]);
			const max = parseFloat(range.split('-')[1]);
			if (isNaN(max)) {
				if (min === val) {
					return true;
				}
			} else if (val > min && val <= max) {
				return true;
			} else if (val === 0 && min === 0) {
				return true;
			}
		}
		return false;
	}
}
